var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "invoice-preview-wrapper" },
    [
      _c(
        "b-row",
        { staticClass: "invoice-preview" },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                {
                  staticClass: "invoice-preview-card px-1",
                  attrs: { "no-body": "", id: "invoice-preview-card" },
                },
                [
                  _c("b-card-body", { staticClass: "pb-0 px-0" }, [
                    _c("div", { staticClass: "row align-items-center mb-2" }, [
                      _c("div", { staticClass: "col-3" }, [_c("Logo")], 1),
                      _c("div", { staticClass: "col-9" }, [
                        _c("div", {}, [_c("CompanyName")], 1),
                        _c("div", {}, [_c("Address")], 1),
                      ]),
                    ]),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", [
                          _c("h4", { staticClass: "mb-1" }, [
                            _vm._v("Customer"),
                          ]),
                          _c(
                            "div",
                            { staticClass: "mt-1" },
                            [
                              _vm.custName
                                ? _c("b-card-text", { staticClass: "mb-25" }, [
                                    _vm._v("Customer ABC"),
                                  ])
                                : _vm._e(),
                              _vm.custAddress
                                ? _c("b-card-text", { staticClass: "mb-25" }, [
                                    _vm._v("Some Road, Somewhere"),
                                  ])
                                : _vm._e(),
                              _vm.custAddress
                                ? _c("b-card-text", { staticClass: "mb-25" }, [
                                    _vm._v("City X"),
                                  ])
                                : _vm._e(),
                              _c("b-card-text", { staticClass: "mb-25" }, [
                                _vm._v("123000"),
                              ]),
                              _c("b-card-text", { staticClass: "mb-0" }, [
                                _vm._v("customer1@gmail.com"),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "col-6 text-right" }, [
                        _vm.invoiceNo
                          ? _c("h4", { staticClass: "invoice-title mb-1" }, [
                              _vm._v(" Invoice No "),
                              _c("span", { staticClass: "invoice-number" }, [
                                _vm._v("#INV1041"),
                              ]),
                            ])
                          : _vm._e(),
                        _c("div", { staticClass: "text-right" }, [
                          _vm.invoiceDate
                            ? _c(
                                "div",
                                { staticClass: "row invoice-date-wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-6 d-flex justify-content-end",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "invoice-date-title" },
                                        [_vm._v("Created On:")]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "col-md-6 col-6" }, [
                                    _c("p", { staticClass: "invoice-date" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDate(_vm.currentDate())
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.dueDate
                            ? _c(
                                "div",
                                { staticClass: "row invoice-date-wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-6 d-flex justify-content-end",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "invoice-date-title" },
                                        [_vm._v("Due Date:")]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "col-md-6 col-6" }, [
                                    _c("p", { staticClass: "invoice-date" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDate(
                                              _vm.addDays(_vm.currentDate(), 3)
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.salesRep
                            ? _c(
                                "div",
                                { staticClass: "row invoice-date-wrapper" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-6 d-flex justify-content-end",
                                    },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "invoice-date-title" },
                                        [_vm._v("Salesperson:")]
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "col-md-6 col-6" }, [
                                    _c("p", { staticClass: "invoice-date" }, [
                                      _vm._v("Salesperson 1"),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]),
                      ]),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "mt-3" },
                    [
                      _c("b-table-lite", {
                        attrs: {
                          border: "",
                          responsive: "",
                          items: _vm.products,
                          fields: (_vm.productImage
                            ? [{ key: "productImage", label: "Product Image" }]
                            : []
                          ).concat(
                            [{ key: "itemName", label: "Product Name" }],
                            [{ key: "description", label: "Description" }],
                            [{ key: "quantity", label: "Quantity" }],
                            [{ key: "price", label: "Unit Price" }],
                            [{ key: "cost", label: "Total Cost" }]
                          ),
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "cell(productImage)",
                            fn: function (data) {
                              return [
                                _c("img", {
                                  staticStyle: {
                                    "max-width": "50px",
                                    height: "auto",
                                  },
                                  attrs: {
                                    src: data.item.productImageUrl,
                                    alt: "Product Image",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-card-body",
                    { staticClass: "invoice-padding px-0 pb-0" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "mt-md-0 mt-3",
                              attrs: {
                                cols: "12",
                                md: "6",
                                order: "2",
                                "order-md": "1",
                              },
                            },
                            [
                              _vm.notes
                                ? _c("b-card-text", { staticClass: "mb-0" }, [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-bold" },
                                      [_vm._v("Note: ")]
                                    ),
                                    _c("span", [_vm._v("lorem ipsum")]),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "b-col",
                            {
                              staticClass: "mt-md-6 d-flex justify-content-end",
                              attrs: {
                                cols: "12",
                                md: "6",
                                order: "1",
                                "order-md": "2",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "invoice-total-wrapper" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "invoice-total-item" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "invoice-total-title" },
                                        [_vm._v("Subtotal:")]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "invoice-total-amount" },
                                        [_vm._v("Rs 614.00")]
                                      ),
                                    ]
                                  ),
                                  _vm.taxAmount
                                    ? _c(
                                        "div",
                                        { staticClass: "invoice-total-item" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-title",
                                            },
                                            [_vm._v("VAT:")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-amount",
                                            },
                                            [_vm._v("Rs 0.00")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c("hr", { staticClass: "my-50" }),
                                  _vm.totalAmount
                                    ? _c(
                                        "div",
                                        { staticClass: "invoice-total-item" },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-title",
                                            },
                                            [_vm._v("Total:")]
                                          ),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "invoice-total-amount",
                                            },
                                            [_vm._v("Rs 614.00")]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    { staticClass: "invoice-total-item" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "invoice-total-title" },
                                        [_vm._v("Total Paid:")]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "invoice-total-amount" },
                                        [_vm._v("Rs 614.00")]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "invoice-total-item" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "invoice-total-title" },
                                        [_vm._v("Balance:")]
                                      ),
                                      _c(
                                        "p",
                                        { staticClass: "invoice-total-amount" },
                                        [_vm._v("Rs 0.00")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.paymentTerms
                    ? _c(
                        "b-card",
                        { attrs: { title: "Payments" } },
                        [
                          _c("b-table", {
                            staticClass: "table-payment",
                            attrs: {
                              responsive: "",
                              items: _vm.paymentData,
                              fields: [
                                {
                                  key: "settlementDate",
                                  label: "Settlement Date",
                                },
                                { key: "amountPaid", label: "Amount Paid" },
                              ],
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }